import { render } from "./tabsPage.vue?vue&type=template&id=098a36e0&scoped=true"
import script from "./tabsPage.vue?vue&type=script&lang=js"
export * from "./tabsPage.vue?vue&type=script&lang=js"

import "./tabsPage.vue?vue&type=style&index=0&id=098a36e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098a36e0"]])

export default __exports__